import { Injectable } from '@angular/core';
import { OrganizationDataService } from 'src/app/core/services/http/organization-data/organization-data.service';

@Injectable({
  providedIn: 'root',
})
export class OrganizationDetailsService {
  private hasOrgSyncedKeys: boolean = true;
  private countryName: string;

  constructor(private organizationDataService: OrganizationDataService) {}

  getHasSyncedKeys() {
    return this.hasOrgSyncedKeys;
  }

  getCountryName() {
    return this.countryName;
  }

  setupOrgainzationData() {
    this.organizationDataService.getOrganizationData().subscribe((result) => {
      this.countryName = result.country;
      this.hasOrgSyncedKeys = result.hasSyncedKeys;
    });
  }
}
